import { Button, Card, ConfigProvider, Row, Space, theme } from 'antd';
import { deepEqual } from 'assert';
import { useMemo } from 'react';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditUserFormValues } from '../../../../../../../../types/userform';
import ResetFormButton from '../../../../../../../components/Forms/ResetFormButton';
import { IEmail, IPhone } from '../../../../../../../model/types';
import CustomUserFieldsContainer from './CustomUserFormFieldsContainer';
import StandartUserFieldsContainer from './StandartUserFieldsContainer';

const isDeepEqual = (currentValue: IEmail[] | IPhone[], defaultValue: IEmail[] | IPhone[]) => {
    try {
        deepEqual(currentValue, defaultValue);
        return true;
    } catch (error) {
        return false;
    }
};

const EditUserFieldsContainer = ({ userId }: { userId: string }) => {
    const { t } = useTranslation('forms');
    const {
        token: { marginSM, paddingXXS, borderRadius }
    } = theme.useToken();
    const { reset } = useFormContext<EditUserFormValues>();
    const {
        defaultValues: { secondaryEmails: defaultSecondaryEmails, secondaryPhones: defaultSecondaryPhones },
        dirtyFields
    } = useFormState<EditUserFormValues>();
    const secondaryEmailFields = useWatch<EditUserFormValues, 'secondaryEmails'>({ name: 'secondaryEmails' });
    const secondaryPhoneFields = useWatch<EditUserFormValues, 'secondaryPhones'>({ name: 'secondaryPhones' });
    const isSecondaryEmailsFieldChanged = !isDeepEqual(secondaryEmailFields, defaultSecondaryEmails as IEmail[]);
    const isSecondaryPhonesFieldChanged = !isDeepEqual(secondaryPhoneFields, defaultSecondaryPhones as IPhone[]);
    // TODO: cagri, react-hook-form => Removing secondary phone/email field does not trigger dirtyState change, only when its defaultValue has single item. i.e, ['+905554545454'] changes to [] and library does not recognize its dirty state
    // HACK: This is as hack to reflect the form is actually dirty,
    const isDisabled = Object.keys(dirtyFields).length
        ? false
        : isSecondaryEmailsFieldChanged || isSecondaryPhonesFieldChanged
        ? false
        : true;

    const memoizedStandartUserFields = useMemo(() => <StandartUserFieldsContainer userId={userId} />, [userId]);

    return (
        <ConfigProvider getPopupContainer={(trigger) => trigger?.parentElement}>
            <Space direction="vertical" size="small" className="full-width">
                {memoizedStandartUserFields}
                <Card
                    bodyStyle={{ padding: paddingXXS * 3 }}
                    style={{
                        borderRadius: borderRadius,
                        border: '1px solid rgba(0, 0, 0, 0.12)',
                        marginBottom: marginSM
                    }}
                >
                    <CustomUserFieldsContainer isActive={true} />
                    <Row justify="space-between" style={{ marginTop: marginSM }}>
                        <ResetFormButton onClick={() => reset()} disabled={isDisabled} />
                        <Button type="primary" htmlType="submit" disabled={isDisabled}>
                            {t('userForm.saveChanges')}
                        </Button>
                    </Row>
                </Card>
            </Space>
        </ConfigProvider>
    );
};

export default EditUserFieldsContainer;
